import { fontSizes } from '../../../../constants/constants';
import dynamicfunction from '../../../../utils/dynamicfunction';
import { ErrorText, InputField, RadioButton, RowView, Text } from '../index';
import CustomInput from '../../../../components/CustomInput';
const UsEntitiesFinancialInstitutions = ({
  getContent,
  values,
  setFieldValue,
  setFieldError,
  setFieldTouched,
  touched,
  optionsYesOrNO,
  errors,
}) => {
  const { TextWeight } = dynamicfunction();

  return (
    <>
      <div className='pt-3 sm:pt-5'>
        <Text
          text={getContent('us_entities_financial_institutions')}
          size={fontSizes.h18}
          isTruncate={false}
          weight={TextWeight.medium}
          className='block'
          isRequired={true}
        />
      </div>
      <RowView className='pt-3 sm:pt-5' isResponsive>
        <div className='w-full'>
          <RadioButton
            label={getContent('specified_us_person')}
            value={values?.fatcaClassificationIsSpecifiedUsPerson}
            onChange={(e) => {
              setFieldValue('fatcaClassificationIsSpecifiedUsPerson', e);
              setFieldTouched('fatcaClassificationIsSpecifiedUsPerson', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.fatcaClassificationIsSpecifiedUsPerson ? errors?.fatcaClassificationIsSpecifiedUsPerson : '')}
          />
        </div>
        <div className='w-full'>
          <RadioButton
            label={getContent('us_person_not_specified')}
            value={values?.usPersonWhoIsNotASpecifiedUsPerson}
            onChange={(e) => {
              setFieldValue('usPersonWhoIsNotASpecifiedUsPerson', e);
              setFieldTouched('usPersonWhoIsNotASpecifiedUsPerson', false);
            }}
            options={optionsYesOrNO}
            required={false}
          />
          <ErrorText
            text={getContent(touched?.usPersonWhoIsNotASpecifiedUsPerson ? errors?.usPersonWhoIsNotASpecifiedUsPerson : '')}
          />
        </div>
        <div className='lg:w-full hidden lg:block'></div>
      </RowView>
      {Number(values?.fatcaClassificationIsSpecifiedUsPerson) === 1 && (
        <div className='pt-3 sm:pt-5'>
          <CustomInput
                          isRounded
            label={getContent('us_tin')}
            value={values?.fatcaClassificationUsTinNumber}
            onChange={(e) => {
              setFieldValue('fatcaClassificationUsTinNumber', e.target.value);
              setFieldTouched('fatcaClassificationUsTinNumber', true, false);
            }}
            isRequired={false}
            placeholder={getContent('placeholder_us_tin')}
            errorMessage={getContent(touched?.fatcaClassificationUsTinNumber ? errors?.fatcaClassificationUsTinNumber : '')}
          />
        </div>
      )}
    </>
  );
};
export default UsEntitiesFinancialInstitutions;
